import React, { useState } from "react";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    orderNumber: "",
    subject: "Product & fit",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const updateField = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    if (errors[name]) setErrors((current) => ({ ...current, [name]: "" }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!formData.fullName.trim()) nextErrors.fullName = "Enter your full name.";
    if (!formData.email.trim()) {
      nextErrors.email = "Enter your email address.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      nextErrors.email = "Enter a valid email address.";
    }
    if (formData.message.trim().length < 10) nextErrors.message = "Tell us a little more so we can help.";

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    setIsSubmitting(true);
    window.setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 600);
  };

  return (
    <main className="contact">
      <header className="contact__header page-width">
        <span className="eyebrow">Customer care</span>
        <h1>Contact us</h1>
        <p>If you have a question about an order, a fit, or the way to care for your denim, send us a note.</p>
      </header>

      <div className="contact__layout page-width">
        <aside>
          <h2>We’re here to help.</h2>
          <dl>
            <div><dt>Email</dt><dd><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a></dd></div>
            <div><dt>Phone</dt><dd><a href={`tel:${siteConfig.contact.phone.replace(/\s/g, "")}`}>{siteConfig.contact.phone}</a></dd></div>
            <div><dt>Workshop hours</dt><dd>Monday–Friday<br />9am–5pm Pacific</dd></div>
          </dl>
          <p>We usually reply within one business day.</p>
        </aside>

        {submitted ? (
          <section className="contact__success" role="status">
            <div><FiCheck aria-hidden="true" /></div>
            <span className="eyebrow">Message sent</span>
            <h2>Thanks for getting in touch.</h2>
            <p>We have your note and will reply to {formData.email} as soon as we can.</p>
            <button type="button" onClick={() => {
              setSubmitted(false);
              setFormData({ fullName: "", email: "", orderNumber: "", subject: "Product & fit", message: "" });
            }}>Send another message</button>
          </section>
        ) : (
          <form className="contact__form" onSubmit={handleSubmit} noValidate>
            <div className="contact__row">
              <label>
                <span>Full name</span>
                <input name="fullName" value={formData.fullName} onChange={updateField} aria-invalid={Boolean(errors.fullName)} />
                {errors.fullName && <small role="alert">{errors.fullName}</small>}
              </label>
              <label>
                <span>Email address</span>
                <input type="email" name="email" value={formData.email} onChange={updateField} aria-invalid={Boolean(errors.email)} />
                {errors.email && <small role="alert">{errors.email}</small>}
              </label>
            </div>
            <div className="contact__row">
              <label>
                <span>Order number <small>Optional</small></span>
                <input name="orderNumber" value={formData.orderNumber} onChange={updateField} />
              </label>
              <label>
                <span>Subject</span>
                <select name="subject" value={formData.subject} onChange={updateField}>
                  <option>Product &amp; fit</option>
                  <option>Order status</option>
                  <option>Shipping &amp; returns</option>
                  <option>Repairs &amp; care</option>
                  <option>Something else</option>
                </select>
              </label>
            </div>
            <label>
              <span>Comments / questions</span>
              <textarea name="message" rows="7" value={formData.message} onChange={updateField} aria-invalid={Boolean(errors.message)} />
              {errors.message && <small role="alert">{errors.message}</small>}
            </label>
            <button className="button button--accent" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending…" : "Send message"} {!isSubmitting && <FiArrowRight aria-hidden="true" />}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}

export default Contact;
